var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10932_239177)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10932_239177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68204 0.0814028C7.88104 -0.0271343 8.12157 -0.0271343 8.32057 0.0814028L9.89784 0.94176C11.1709 1.63615 12.5978 2 14.0479 2H14.668C15.0362 2 15.3346 2.29848 15.3346 2.66667V6.14813C15.3346 9.79507 13.3493 13.1528 10.1538 14.9103L8.32257 15.9175C8.1225 16.0275 7.8801 16.0275 7.68004 15.9175L5.84878 14.9103C2.6533 13.1528 0.667969 9.79507 0.667969 6.14813V2.66667C0.667969 2.29848 0.966449 2 1.33464 2H1.95469C3.40479 2 4.83171 1.63615 6.10474 0.94176L7.68204 0.0814028ZM5.33464 7.33333C5.33464 5.86057 6.52854 4.66667 8.0013 4.66667C9.47404 4.66667 10.668 5.86057 10.668 7.33333C10.668 8.80607 9.47404 10 8.0013 10C6.52854 10 5.33464 8.80607 5.33464 7.33333Z",
    fill: "#D1DAE7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10932_239177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10932_239177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcmp);
export default __webpack_public_path__ + "static/media/ECMP.42f0fb8e922bdedd78a4b27af2c880ed.svg";
export { ForwardRef as ReactComponent };